import { render, staticRenderFns } from "./DownloadLR.vue?vue&type=template&id=0927723a&scoped=true&"
import script from "./DownloadLR.vue?vue&type=script&lang=js&"
export * from "./DownloadLR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927723a",
  null
  
)

export default component.exports